import React from "react";

export const Field = ({ label, children }) => (
    <div>
        <div className="overline mb-3">{label}</div>
        {children}
    </div>
);

export const ImageGuidelines = ({ title, lines }) => (
    <div className="mt-3 border border-zinc-800 bg-[#0A0A0A] p-4">
        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#FFD000] mb-2">
            {title}
        </div>
        <ul className="space-y-1 text-xs text-zinc-400 leading-relaxed">
            {lines.map((line) => (
                <li key={line} className="flex gap-2">
                    <span className="text-zinc-600">›</span>
                    <span>{line}</span>
                </li>
            ))}
        </ul>
    </div>
);
